import UAParser from 'ua-parser-js';

export const getUserAgent = () => {
  return new UAParser(window.navigator.userAgent).getResult();
};
